import 'reflect-metadata';
import { Property, Type } from '@dipscope/type-manager';
import { EntityMap } from '../tilebase/Entity';
import 'reflect-metadata';
import logger from '../../logger';
import KTile from './KTile';
import KMeeple from './KMeeple';
import { KNodeDefClass } from './KTileGameConfig';
import { KPlayerResource, KResource } from './KResource';

export type KEntitType = 'c' | 'r' | 'f' | 'w' | 'wr';

@Type({ injectable: true, discriminant: 'KEntityTypeMap' })
export class KEntitTypeMap extends EntityMap {
  constructor() {
    logger.info('new KEntityMap');
    super([
      ['r', { singleNodeType: false, completable: true, completedScore: 1, uncompletedScore: 1 }],
      ['f', { singleNodeType: false, completable: false, completedScore: 1, uncompletedScore: 0 }],
      ['w', { singleNodeType: false, completable: true, completedScore: 2, uncompletedScore: 1 }],
      ['wr', { singleNodeType: false, completable: true, completedScore: 2, uncompletedScore: 1 }],
      ['c', { singleNodeType: true, completable: true, completedScore: 2, uncompletedScore: 1 }]
    ]);
  }
}

@Type({
  discriminant: 'KNode',
  injectable: true
})
class KNode {
  @Property() id: number;
  @Property() x: number;
  @Property() y: number;
  @Property([Number]) conns: number[] = [];
  @Property([Number]) cities: number[] = [];
  @Property([Number]) roads: number[] = [];
  @Property([Number]) wald: number[] = [];
  @Property([KNode]) nbs: KNode[] = [];
  @Property() type: KEntitType;
  @Property() meeple: KMeeple;
  @Property(() => KTile) tile: KTile;
  @Property() resource?: KResource;
  @Property() mine?: boolean;

  constructor(obj: KNodeDefClass) {
    if (!obj) return;
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }
}

export default KNode;
